import AppRoute from "./common/AppRoute";

function App() {
  return (
    <>
      <AppRoute />
    </>
  );
}

export default App;
